import { Button } from '@material-ui/core';
import styled from 'styled-components';

export const CustomButton = styled(Button)`
  font-weight: 700;
  padding: 0.5rem 1.5rem;
  min-width: 110px;
  color: white;
`;
